import * as yup from "yup";

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	description: yup.string().min(1, translate("Descrição é requerida")).required(translate("Descrição é requerida")),
	title: yup.string().min(1, translate("Título é requerido")).required(translate("Título é requerido"))
});

export const addCommentSchema = (translate: Function) => yup.object().shape({
	description: yup.string().min(1, translate("Descrição é requerida")).required(translate("Descrição é requerida"))
});

export default  addAndChangeSchema;
